import type { TbEventWithId } from '@moment-golf/types';
import { isEventPast } from '@moment-golf/shared';

/**
 * Returns eventData sorted and ordered for dropdown display:
 * - Upcoming (endDate not past): oldest startDate first
 * - Completed (endDate past): newest startDate first
 */
export function getSegmentedEventOptions(eventData: TbEventWithId[]): TbEventWithId[] {
  const upcoming = eventData
    .filter((e) => !isEventPast(e.endDate))
    .sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
  const completed = eventData
    .filter((e) => isEventPast(e.endDate))
    .sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());
  return [...upcoming, ...completed];
}
